import { X } from 'lucide-react';
import React, { useState } from 'react';

const TaxPreview = ({ isOpen, onClose, documentUrl, documentNumber }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  if (!isOpen || !documentUrl) {
    return null;
  }

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-black/80 overflow-hidden">
      {/* Header */}
      <div className="flex-shrink-0 px-4 pt-6 pb-4 bg-black/90">
        <div className="mx-auto w-full max-w-7xl">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="text-sm font-semibold uppercase tracking-widest text-white/80">
                Document Preview
              </div>
              {documentNumber && (
                <div className="text-sm text-white/60">
                  {documentNumber}
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/15 px-5 py-2 text-sm font-semibold text-white transition hover:bg-white/25 focus:outline-none focus:ring-2 focus:ring-white/50"
            >
              <X className="w-4 h-4" />
              Close
            </button>
          </div>
        </div>
      </div>

      {/* PDF Viewer Container */}
      <div className="flex-1 overflow-hidden relative bg-gray-900">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-white border-t-transparent mb-4"></div>
              <p className="text-white/80 text-sm">Loading document...</p>
            </div>
          </div>
        )}

        {hasError ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center p-8">
              <p className="text-white/80 text-lg mb-2">Failed to load document</p>
              <p className="text-white/60 text-sm mb-4">
                The document could not be displayed. Please check the URL or try again later.
              </p>
              <a
                href={documentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-full bg-green-600 px-6 py-2 text-sm font-semibold text-white transition hover:bg-green-700"
              >
                Open in New Tab
              </a>
            </div>
          </div>
        ) : (
          <iframe
            src={documentUrl}
            className="w-full h-full border-0"
            title="Document Preview"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
            style={{ display: isLoading ? 'none' : 'block' }}
          />
        )}
      </div>
    </div>
  );
};

export default TaxPreview;

